import React, { ComponentType, ReactNode } from 'react'
import { ExternalLink } from 'src/routing/ui/ExternalLink'
import { Link } from 'react-router-dom'
import { css } from 'src/ui/style/css'

const isExternal = (link: string) => link.includes('://')

export type UniversalLinkProps = {
    to: string
    children: ReactNode
    className?: string
    onClick?: () => void
}

const linkInline = css`
  display: inline;
  white-space: normal;
  word-break: normal;      
  overflow-wrap: normal;   
  hyphens: none;           
`
export const UniversalLink: ComponentType<UniversalLinkProps> = ({
    children,
    to,
    className,
    onClick
}) =>
    isExternal(to) ? (
        <ExternalLink
            value={to}
            openInNewTab
            className={className}
            onClick={onClick}
            css={linkInline}
        >
            {children}
        </ExternalLink>
    ) : (
        <Link to={to} css={linkInline} className={className} onClick={onClick}>
            {children}
        </Link>
    )
